import { useEffect } from 'react';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SingleImageUploader from 'src/components/uploads/image-uploader';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import DropdownPlates from 'src/components/dropdown/dropdown-plates';
import DropdownPartners from 'src/components/dropdown/dropdown-partners';
import DropdownPricing from 'src/components/dropdown/dropdown-pricing';
import QuillEditor from 'src/components/quill-editor';
import { getCacheCarPartner } from 'src/utils/cache-data';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import {
  initialValues,
  validationSchema,
  formatWithCommas,
  handleSubmitted,
} from './formik';

export const DetailForm = (props) => {
  const {
    filters = {},
    onFiltersChange,
    item,
    apiCreate,
    apiUpdate,
    apiDelete,
    ...other
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    initialValues(formik, item);

    if (item) {
      const carId = formik.values?.plateField?.value;
      if(carId){
        const partners = getCacheCarPartner();
        const cache = partners[carId];
        if (cache) {
          const card = cache.xd.cardNumber;
          if(card){
            item.currentCard = card;
          }
        }
      }
    } 
  }, [item]);

  const formik = useCustomFormik({
    // initialValues: {},
    validationSchema: validationSchema(item),

    onSubmit: async (values, helpers) => {
      await handleSubmitted(values, item, apiCreate, apiUpdate, apiDelete);

      // helpers.setStatus({ success: false });
      // helpers.setErrors({ submit: error });
      // helpers.setSubmitting(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} {...other}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid container spacing={3} xs={12} md={6}>
              <Grid xs={12} md={6}>
                <StringTextField
                  label="Mã"
                  name="code"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Tên học viên"
                  name="studentName"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Khóa"
                  name="studentName"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label={t(appStr.txt_073)}
                  name="studentName"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Biển số"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Km Ca"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Giờ Ca"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Giờ Đêm"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Giờ B1"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Thời gian đã học"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Đã học"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Km Còn"
                  name="plate"
                  formik={formik}
                  hintValue={item?.quantity}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <DropdownPricing
                  name="pricingField"
                  type='xd'
                  formik={formik}
                  hintValue={item?.price}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <DropdownPartners
                  name="partnerField"
                  type='xd'
                  formik={formik}
                  hintValue={item?.partner?.label}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <StringTextField
                  label="Số thẻ"
                  name="cardField"
                  formik={formik}
                  inputProps={{ 
                    maxLength: 4,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                    },
                  }} // Set maximum input length to 4 characters
                  hintValue={item?.cardNumber?.slice(-4)}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <DateAndTimePicker
                  label="Ngày tiếp nhiên liệu"
                  name="created"
                  formik={formik}
                  hintValue={item?.paidDate}
                />
              </Grid>

              <Grid xs={12}>
                <QuillEditor
                  name="note"
                  value={formik.values.note}
                  onChange={(content) => formik.setFieldValue('note', content)}
                  placeholder='Ghi chú nếu có'
                  sx={{ height: 110 }}
                />
              </Grid>
            </Grid>
            <Grid xs={12} md={6}>
              <SingleImageUploader formik={formik} />
            </Grid>
          </Grid>
        </CardContent>

        <SubmitButton formik={formik} isRemove={item || false} />
      </Card>
    </form>
  );
};
